import React from 'react';
import { Users } from 'lucide-react';
import { crowdCount } from '../../utils/crowd';
export default function CrowdInsight({ metadata, compact = false }: { metadata: unknown; compact?: boolean }) {
  const count = crowdCount(metadata);
  if (count === null) return null;
  return <div className={compact ? 'inline-flex items-center gap-1 text-xs text-primary mt-1' : 'rounded-xl border border-primary/20 bg-primary/5 p-5 flex items-center gap-4'}>
    <Users size={compact ? 14 : 28} /><div>{!compact && <h2 className="font-semibold">Crowd detection</h2>}
      <strong>{count} {count === 1 ? 'person' : 'people'} in frame</strong>
      {!compact && <p className="text-sm text-text-secondary mt-1">Detected people in this snapshot. This count does not identify every person or measure the room’s full occupancy.</p>}</div>
  </div>;
}
